import { useLanguage } from "../context/LanguageContext";
import { Instagram, Linkedin } from "lucide-react";

const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M19.6 6.32a4.85 4.85 0 0 1-3.77-2.62 4.83 4.83 0 0 1-.6-2.7h-3.4v13.9a2.97 2.97 0 1 1-2.97-2.97c.21 0 .42.02.62.07V8.49a6.43 6.43 0 0 0-.62-.03 6.4 6.4 0 1 0 6.4 6.4V8.5a8.2 8.2 0 0 0 4.92 1.61V6.7c-.2 0-.39-.13-.58-.38Z" />
  </svg>
);

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer
      data-testid="site-footer"
      className="relative pt-20 pb-10 bg-[var(--text-primary)] text-[var(--bg-base)] overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 mb-16">
          {/* Brand */}
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <img
                src="https://customer-assets.emergentagent.com/job_healthy-future/artifacts/heje4o4g_saha-logo%20-%20Edited%20-%20Edited.png"
                alt="Saha Lab"
                width="48"
                height="48"
                className="w-12 h-12 object-contain"
                loading="lazy"
              />
              <div>
                <div className="font-display text-lg font-medium">Saha Lab</div>
                <div className="text-xs text-[var(--brand-gold)] tracking-widest">
                  صحة لاب
                </div>
              </div>
            </div>
            <p className="font-display text-3xl md:text-4xl leading-tight max-w-md">
              {t.footer.tagline}
            </p>
          </div>

          {/* Link cols */}
          <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8">
            <FooterCol
              title={t.footer.sections.explore}
              links={[
                { href: "#products", label: t.footer.links.products },
                { href: "#mission", label: t.footer.links.mission },
                { href: "#contact", label: t.footer.links.contact },
              ]}
            />
            <FooterCol
              title={t.footer.sections.company}
              links={[
                { href: "#mission", label: t.footer.links.story },
                { href: "#", label: t.footer.links.sustainability },
                { href: "#", label: t.footer.links.careers },
              ]}
            />
            <div>
              <div className="text-xs uppercase tracking-[0.25em] text-[var(--brand-gold)] mb-4">
                {t.footer.sections.connect}
              </div>
              <div className="flex items-center gap-3">
                <SocialBtn
                  href="#"
                  label={t.footer.links.instagram}
                  testId="social-instagram"
                >
                  <Instagram className="w-4 h-4" strokeWidth={1.5} />
                </SocialBtn>
                <SocialBtn
                  href="#"
                  label={t.footer.links.tiktok}
                  testId="social-tiktok"
                >
                  <TikTokIcon className="w-4 h-4" />
                </SocialBtn>
                <SocialBtn
                  href="#"
                  label={t.footer.links.linkedin}
                  testId="social-linkedin"
                >
                  <Linkedin className="w-4 h-4" strokeWidth={1.5} />
                </SocialBtn>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between text-xs text-white/50">
          <div>{t.footer.copyright}</div>
          <div className="flex items-center gap-2">
            <span className="w-1.5 h-1.5 rounded-full bg-[var(--brand-gold)]" />
            <span>Launching Vitamin Water 2026</span>
          </div>
        </div>
      </div>

      {/* Giant brand wordmark backdrop */}
      <div
        aria-hidden="true"
        className="pointer-events-none select-none absolute -bottom-10 inset-x-0 text-center font-display text-[18vw] leading-none text-white/[0.03]"
      >
        SAHA
      </div>
    </footer>
  );
};

const FooterCol = ({ title, links }) => (
  <div>
    <div className="text-xs uppercase tracking-[0.25em] text-[var(--brand-gold)] mb-4">
      {title}
    </div>
    <ul className="space-y-3">
      {links.map((l, i) => (
        <li key={i}>
          <a
            href={l.href}
            className="text-sm text-white/80 hover:text-white transition-colors"
          >
            {l.label}
          </a>
        </li>
      ))}
    </ul>
  </div>
);

const SocialBtn = ({ href, children, label, testId }) => (
  <a
    href={href}
    aria-label={label}
    data-testid={testId}
    className="w-10 h-10 rounded-full bg-white/5 hover:bg-[var(--brand-gold)] hover:text-[var(--text-primary)] inline-flex items-center justify-center transition-colors border border-white/10"
  >
    {children}
  </a>
);

export default Footer;
